import { TooltipPointerDirectionEnum } from '../../services/tooltip-sequence/i2g-tooltip-sequence.data';

export const CORNER_OFFSET = 10;
export const POINTER_SIZE = 11;
export const BASE_POINTER_DISTANCE = 15;
export const DEFAULT_POINTER_DIRECTION = TooltipPointerDirectionEnum.up;
